import { ca } from '@cian/analytics';

import { TDeviceType } from '@cian/ui-kit';
import { getSiteType } from '../../utils/getSiteType';
import { EPageType } from '../../types/redux/page';
import { mapPageTypeToAnalytics } from '../../utils/getPageviewObject';

export const trackRequestForSaleClick = (deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    page: {
      pageType: 'EstateCalculator',
      siteType: getSiteType(deviceType),
      extra: {
        banner_location: 'after_eval',
      },
    },
  });
};

export const trackSendDemandRequestClick = (deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor_reserve',
    action: 'Click',
    label: 'Banner',
    page: {
      pageType: 'EstateCalculator',
      siteType: getSiteType(deviceType),
      extra: {
        banner_location: 'after_eval',
      },
    },
  });
};

export const trackAddOfferClick = (pageType: EPageType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: mapPageTypeToAnalytics[pageType],
    action: 'Click',
    label: 'go_to_add_form',
  });
};

export const trackRequestForSaleIntoView = () => {
  ca('teaser', {
    product: {
      name: 'Application_to_realtor',
    },
  });
};

export const trackSendDemandRequestIntoView = () => {
  ca('teaser', {
    product: {
      name: 'application_to_realtor_reserve',
    },
  });
};

export const trackAddOfferVisible = () => {
  ca('teaser', {
    product: {
      name: 'add_form_entry',
    },
  });
};
